import React, { FC } from 'react';
import './styles.css';
import AboutusBG from 'src/assets/img/new-aboutus.png';

const Header: FC = () => {

    return (
        <section className="inner-top-header" id="hero" style={{ background: ` url(${AboutusBG})` }} >
            <div className="hero-container d-flex">
                <div className="container" >
                    <div className="spac_02"></div>
                    <div className="row top-course-block">
                        <div className="top-course-header text-center">
                            <h1>ABOUT <span>BANGALORESTUDY.COM</span></h1>
                        </div>
                    </div>
                    <div className="spac_02"></div>
                </div>
            </div>
        </section>
    );
};

export default Header;